interface ApiConfig {
 API_URL: string
}

interface Config {
 api: ApiConfig
 /** IANA zone for UI date inputs and display (match Laravel APP_TIMEZONE). */
 appTimezone: string
}

const config: Config = {
 api: {
 // API root only (must end with /api). Do not set this to a full route like .../api/auth/login.
 API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
 },
 appTimezone: process.env.REACT_APP_TIMEZONE || 'Africa/Cairo',
}

export default config
